import AdminImputationList from '@/components/Imputation/AdminImputationList'
import AdminImputationForm from '@/components/Imputation/AdminImputationForm'
import AdminImputationDetail from '@/components/Imputation/AdminImputationDetail'

let ImputationRouter = [
{
  path: '/admin/imputation',
  name: 'AdminImputationList',
  component: AdminImputationList,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/imputation/new',
  name: 'AdminImputationNew',
  component: AdminImputationForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/imputation/:id/edit',
  name: 'AdminImputationEdit',
  component: AdminImputationForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/impuation/:id',
  name: 'AdminImputationDetail',
  component: AdminImputationDetail,
  meta: {
    requiresAuth: true
  }
}]

export default ImputationRouter


// WEBPACK FOOTER //
// ./src/components/Imputation/router.js